import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { AdminUpdateActorAdminDashboardSettingsMutationDocument } from '@docpace/admin-graphql/dist/urql.types'
import { AdminUpdateActorAdminDashboardSettingsMutationResultFragment, AdminUpdateActorAdminDashboardSettingsMutationParams } from '@docpace/admin-graphql'

const typedAdminUpdateActorAdminDashboardSettingsMutationDocument = AdminUpdateActorAdminDashboardSettingsMutationDocument as TypedDocumentNode<AdminUpdateActorAdminDashboardSettingsMutationResultFragment, Partial<AdminUpdateActorAdminDashboardSettingsMutationParams>>

export function useAdminUpdateActorAdminDashboardSettingsMutation(opts?: useMutation.Options<AdminUpdateActorAdminDashboardSettingsMutationResultFragment, Partial<AdminUpdateActorAdminDashboardSettingsMutationParams>>){
    return useMutation(typedAdminUpdateActorAdminDashboardSettingsMutationDocument, opts)
}
